import React from "react";
import Loadable from "../../react-loadable";

const TimePicker = Loadable({
  loader: () => import("./TimePicker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default TimePicker;



// WEBPACK FOOTER //
// ./_antd1.11.2/time-picker/index.jsx